import { render, staticRenderFns } from "./edit-form-section.vue?vue&type=template&id=9e80bafa&scoped=true&"
import script from "./edit-form-section.vue?vue&type=script&lang=ts&"
export * from "./edit-form-section.vue?vue&type=script&lang=ts&"
import style0 from "./edit-form-section.vue?vue&type=style&index=0&id=9e80bafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e80bafa",
  null
  
)

export default component.exports